import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * Öppet/stängt-läget för IA-prislistans sidopanel.
 *
 * Ligger i en context och inte i Navbar, eftersom Navbar monteras om på varje
 * sida — panelen skulle då slå igen så fort man bytte vy. Poängen med den är
 * det motsatta: att kunna gå runt i portalen med prislistan uppslagen bredvid.
 */
const PrislistaPanelContext = createContext(null);

export const PrislistaPanelProvider = ({ children }) => {
  const [oppen, setOppen] = useState(false);

  const oppna = useCallback(() => setOppen(true), []);
  const stang = useCallback(() => setOppen(false), []);
  const vaxla = useCallback(() => setOppen(prev => !prev), []);

  const varde = useMemo(() => ({ oppen, oppna, stang, vaxla }), [oppen, oppna, stang, vaxla]);

  return (
    <PrislistaPanelContext.Provider value={varde}>
      {children}
    </PrislistaPanelContext.Provider>
  );
};

/**
 * Returnerar ett tomt läge om providern saknas, så att en komponent som råkar
 * hamna utanför den inte kraschar — knappen blir bara verkningslös.
 */
export const usePrislistaPanel = () => {
  return useContext(PrislistaPanelContext) || {
    oppen: false,
    oppna: () => {},
    stang: () => {},
    vaxla: () => {}
  };
};

export default PrislistaPanelContext;
